import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import CameraView from './CameraView';
import styles from './CCTVMonitor.module.css';
import { cctvRequester } from 'App';
import { requester } from 'App';


const VendorCCTVMonitor = () => {
    const [stores, setStores] = useState([]);
    const [currentStoreIndex, setCurrentStoreIndex] = useState(0);
    const [currentCameras, setCurrentCameras] = useState([]);
    const [autoPlay, setAutoPlay] = useState(true);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const { token } = useSelector((state) => state.auth);

    useEffect(() => {
        const fetchStores = async () => {
            try {
                setLoading(true);
                requester.findAllStoresByVendorUserName((result) => {
                    if (result.data.length > 0) {
                        setStores(result.data)
                        fetchCamerasForStore(result.data[0].storeCode);
                    }
                })
            } catch (err) {
                setError('매장 정보를 불러오는데 실패했습니다.');
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            fetchStores();
        }

        return () => {
            setCurrentCameras([]);
        };
    }, [token, requester]);

    const fetchCamerasForStore = async (storeCode) => {
        try {
            setLoading(true);
            const response = await cctvRequester.getCameraWithStoreCode(storeCode, token);

            // cameras 배열에서 각 카메라의 json 데이터만 추출
            const camerasData = response.cameras.map(camera => ({
                id: camera.id,
                json: camera.json
            }));            
            setCurrentCameras(camerasData);
            setError(null);
        } catch (err) {
            setError(`매장 코드 ${storeCode}의 카메라 정보를 불러오는데 실패했습니다.`);
            setCurrentCameras([]);
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!autoPlay || stores.length === 0) return;

        const interval = setInterval(() => {
            const nextIndex = (currentStoreIndex + 1) % stores.length;
            setCurrentStoreIndex(nextIndex);
            fetchCamerasForStore(stores[nextIndex].storeCode);
        }, 10000);

        return () => clearInterval(interval);
    }, [autoPlay, stores.length, currentStoreIndex]);

    const handleStoreClick = async (index) => {
        setCurrentStoreIndex(index);
        setAutoPlay(false);
        await fetchCamerasForStore(stores[index].storeCode);
    };

    if (!token) {
        return <div>인증이 필요합니다.</div>;
    }

    if (loading && stores.length === 0) {
        return <div className={styles.loadingContainer}>매장 정보를 불러오는 중...</div>;
    }

    const currentStore = stores[currentStoreIndex];

    return (
        <div className={styles.container}>
            <div className={styles.controlBar}>
                <div className={styles.buttonGroup}>
                    {stores.map((store, index) => (
                        <button
                            key={store.id}
                            onClick={() => handleStoreClick(index)}
                            className={`${styles.storeButton} ${currentStoreIndex === index ? styles.storeButtonActive : ''
                                }`}
                        >
                            {store.storeName} 
                            {/* ({store.storeCode}) */}
                        </button>
                    ))}
                </div>
                <button
                    onClick={() => setAutoPlay(!autoPlay)}
                    className={`${styles.autoPlayButton} ${autoPlay ? styles.autoPlayButtonActive : styles.autoPlayButtonInactive
                        }`}
                >
                    {autoPlay ? 'Auto Play ON' : 'Auto Play OFF'}
                </button>
            </div>

            <div className={styles.gridContainer}>
                {loading && <div className={styles.loadingContainer}>카메라 정보를 불러오는 중...</div>}

                {!loading && currentCameras.length > 0 && (
                    currentCameras.map((camera, index) => (
                        <CameraView
                            key={camera['@id']}
                            camera={camera}
                            token={token}
                        />
                    ))
                )}

                {!loading && currentCameras.length === 0 && !error && (
                    <div className={styles.noCamera}>
                        {currentStore?.storeName} 
                        {/* ({currentStore?.storeCode})  */}
                        에 등록된 카메라가 없습니다.
                    </div>
                )}

                {error && <div className={styles.error}>{error}</div>}
            </div>
        </div>
    );
};

export default VendorCCTVMonitor;